// extracted by mini-css-extract-plugin
export default {"label":"LocalizationSelect_label","select":"LocalizationSelect_select"};